import { LocaleProvider } from "../../i18n/LocaleContext";
import { SeoHead } from "../seo/SeoHead";
import PageIndex from "../pages/PageIndex";

export default function HomeRoute({ locale, messages }) {
  return (
    <LocaleProvider locale={locale} messages={messages} route="home">
      <SeoHead />
      <PageIndex />
    </LocaleProvider>
  );
}
